import type { ReactNode } from 'react';
import { NavLink } from 'react-router-dom';
import { Button, UiPageHeader } from '../ui';

export interface FilterTab {
  label: string;
  to: string;
  count?: number;
}

/**
 * Wraps `@alpha/ui`'s PageHeader with the filter-tab row. The source renders
 * these as links styled as buttons with the filter carried in the URL — kept as
 * real links so the state stays shareable and back/forward works.
 */
export function PageHeader({
  title,
  description,
  tabs,
  actions,
}: {
  title: string;
  description?: ReactNode;
  tabs?: FilterTab[];
  actions?: ReactNode;
}) {
  return (
    <UiPageHeader title={title} description={description} actions={actions}>
      {tabs && tabs.length > 0 ? (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, marginTop: '1rem' }}>
          {tabs.map((tab) => (
            <NavLink key={tab.to} to={tab.to} end style={{ textDecoration: 'none' }}>
              {({ isActive }) => (
                <Button as="span" size="sm" variant={isActive ? 'gold' : 'outline-gold'}>
                  {tab.label}
                  {typeof tab.count === 'number' ? ` (${tab.count})` : ''}
                </Button>
              )}
            </NavLink>
          ))}
        </div>
      ) : null}
    </UiPageHeader>
  );
}
